import styled from 'styled-components'
import { Select as AntSelect } from 'antd'
import { IStyledProps } from './interface'

export const Select = styled(AntSelect)<IStyledProps>`
  ${props => Number.isInteger(props?.width) ? 'width: ' + props.width + 'px;' : '' }
`